import { useStore, type ViewKey } from "@/state/store";
import { Icon } from "@/components/atoms/Icons";

interface Tab {
  key: ViewKey;
  label: string;
  icon: keyof typeof Icon;
}

/** Le cinque destinazioni principali. Le categorie (Sports, Politics, Crypto,
 *  Culture, Science) restano nel drawer: cinque voci e' gia' il massimo per una
 *  barra da 375px senza stringere i target sotto la soglia di tappabilita'. */
const TABS: Tab[] = [
  { key: "markets", label: "Markets", icon: "Grid" },
  { key: "trending", label: "Trending", icon: "Trending" },
  { key: "portfolio", label: "Portfolio", icon: "Briefcase" },
  { key: "activity", label: "Activity", icon: "Activity" },
  { key: "profile", label: "Profile", icon: "User" },
];

/** Tab bar mobile. Sopra `lg` sparisce: li' c'e' la sidebar. */
export function BottomNav() {
  const view = useStore((s) => s.view);
  const setView = useStore((s) => s.setView);
  const detailSlug = useStore((s) => s.detailSlug);

  // Aprendo un market da una categoria, la tab evidenziata resta quella da cui
  // si e' partiti invece di nessuna.
  const active = (key: ViewKey) =>
    view === key || (view === "market-detail" && key === "markets" && !detailSlug);

  return (
    <nav
      className="glass fixed inset-x-0 bottom-0 z-30 flex border-t border-line lg:hidden"
      // Sugli iPhone la barra finirebbe sotto l'indicatore home.
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      aria-label="Primary"
    >
      {TABS.map((t) => {
        const IconCmp = Icon[t.icon];
        const on = active(t.key);
        return (
          <button
            key={t.key}
            onClick={() => setView(t.key)}
            aria-current={on ? "page" : undefined}
            // Senza, lo screen reader legge il bottone come anonimo: l'icona
            // e' un SVG decorativo e l'etichetta e' troppo piccola per reggere
            // da sola il nome accessibile.
            aria-label={t.label}
            className={`relative flex min-h-[56px] flex-1 flex-col items-center justify-center gap-1 px-1 text-[10px] transition-colors ${
              on ? "text-text" : "text-muted hover:text-text-2"
            }`}
          >
            {on && (
              <span className="absolute inset-x-4 top-0 h-[2px] rounded-b bg-accent shadow-[0_0_12px_var(--accent)]" />
            )}
            <IconCmp size={18} />
            <span className="max-w-full truncate">{t.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
